// extracted by mini-css-extract-plugin
export var aiStarIcon = "_jd-2";
export var container = "_jd-4";
export var dismissButton = "_jd-3";
export var hasPaddingBottom = "_jd-6";
export var last = "_jd-e";
export var scrollbarThumb = "_jd-c";
export var scrollbarTrack = "_jd-b";
export var selected = "_jd-9";
export var spin = "_jd-1";
export var spinning = "_jd-0";
export var suggestionItem = "_jd-d";
export var suggestionsPanel = "_jd-5";
export var tonePill = "_jd-8";
export var tonesContainer = "_jd-7";
export var unselected = "_jd-a";